<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="">
          <div class="panel with-nav-tabs panel-primary">
            <div class="panel-heading">
              <ul class="nav nav-tabs">
                <li
                  v-for="(apartmentGroup, index) in apartmentGroupList"
                  :key="apartmentGroup + index"
                  :class="index === 0 ? 'active' : ''"
                  @click="clickTab(index)"
                >
                  <a :href="`#group${apartmentGroup.id}`" data-toggle="tab">{{
                    $t(apartmentGroup.groupName)
                  }}</a>
                </li>
              </ul>
            </div>
            <div class="panel-body">
              <div class="tab-content">
                <div
                  :class="
                    index === indexSelect
                      ? 'tab-pane fade in active'
                      : 'tab-pane fade'
                  "
                  v-for="(apartmentItem, index) in apartmentGroupList"
                  :key="apartmentItem + index"
                  :id="`#group${apartmentItem.id}`"
                >
                  <div
                    class="col-sm-12 col-md-12"
                    style="padding: 10px; background: #e4e7e8"
                  >
                    <!-- <div class="col-sm-12 col-md-12"> -->
                    <!-- <div class="row"> -->
                    <div
                      v-for="(apartmentData, index) in apartmentItem.apartment"
                      :key="apartmentData + index"
                      class="col-sm-6 col-md-4 col-lg-3"
                      style="padding: 5px; color: white"
                    >
                      <!-- {{ apartmentData }} -->
                      <div
                        :style="
                          `border: 1px solid; padding: 7px; height: 150px; background: ${apartmentData.color}`
                        "
                        v-contextmenu:contextmenu="{
                          trigger: ['contextmenu', 'click']
                        }"
                        v-on:contextmenu.prevent="
                          onClickApartment(apartmentData)
                        "
                      >
                        <!-- <div style="text-align: right"> -->
                        <span
                          v-if="apartmentData.booking_info"
                          style="padding: 5px; background: #006ad4; position: absolute; right: 6px; top: 6px;"
                          >{{
                            formatDateBooking(
                              apartmentData.booking_info.date_check_in,
                              apartmentData.booking_info.date_check_out
                            )
                          }}</span
                        >
                        <!-- </div> -->
                        <div class="apartment-code">
                          {{ apartmentData.apartment_code }}
                        </div>
                        <div>
                          <div>{{ apartmentData.aparment_type }}</div>
                          <div v-if="apartmentData.booking_info">
                            <span style="font-weight: bold">{{
                              apartmentData.booking_info.person_booking
                            }}</span>
                          </div>
                          <div v-else>
                            <span>{{ $t("apartment.numberOfPerson") }}: </span
                            >{{ apartmentData.adults }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--  -->
                    <v-contextmenu ref="contextmenu">
                      <v-contextmenu-item
                        :disabled="isDisableCheckIn"
                        @click="onShowModalCheckIn"
                        ><i class="glyphicon glyphicon-log-in"></i>
                        <span>{{
                          $t("apartmentDiagram.actionList.checkIn")
                        }}</span>
                      </v-contextmenu-item>
                      <v-contextmenu-item
                        :disabled="isDisableCheckOut"
                        @click="onShowCheckOut"
                        ><i class="glyphicon glyphicon-log-out"></i>
                        <span>{{
                          $t("apartmentDiagram.actionList.checkOut")
                        }}</span>
                      </v-contextmenu-item>
                      <v-contextmenu-item
                        @click="onShowModalService"
                        ><i class="fa fa-bell-o" aria-hidden="true"></i>
                        <span>{{
                          $t("apartmentDiagram.actionList.service")
                        }}</span>
                      </v-contextmenu-item>
                      <!-- <v-contextmenu-item>sua phong</v-contextmenu-item> -->
                      <v-contextmenu-item
                        @click="onShowModalCleanRoom"
                        ><i class="fa fa-eraser" aria-hidden="true"></i>
                        <span>{{
                          $t(actionCleanText)
                        }}</span></v-contextmenu-item
                      >
                    </v-contextmenu>
                    <!-- </div> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </row>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!-- apartmentInBooking -->
    <div
      class="modal fade"
      id="modal-check-in-booking-id"
      :ref="`modal-check-in-booking`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseModalCheckIn"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartmentBooking.apartmentInformation") }}
            </h4>
          </div>
          <div
            class="modal-body"
            :style="`overflow-y: auto; height: ${screenHight}px`"
          >
            <apartment-in-booking
              :isHideApartmentList="true"
              :apartmentIdProps="apartmentIdSelect"
              :bookingId="bookingId"
              @callBackApartmentDiagram="getApartmentInGroup"
              ref="apartmentInBooking"
            />
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <check-out-modal
      ref="checkOutApartmentInBookingModal"
      :bookingId="bookingId"
      :apartmentId="apartmentIdSelect"
      @callBackDataCheckOut="getApartmentInGroup"
    />
    <!--  -->
    <div
      class="modal fade"
      :ref="`modal-clean-room`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onHideModalCleanRoom"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartmentDiagram.actionList.cleanTheRoom") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                {{ $t(notiActionClean) }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onHideModalCleanRoom"
            >
              {{ $t("common.delete_modal.btnNo") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onConfirmCleanRoom"
            >
              {{ $t("common.delete_modal.btnYes") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- <management-service-order-detail /> -->
    <div
      class="modal fade"
      :ref="`modal-service-order`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseModalAddService"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding-top: 0; padding-bottom: 0">
            <div class="row">
              <management-service-order-detail
                ref="managementServiceOrderDetail"
                @onCloseModalAddService="onCloseModalAddService"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import BookingActionEnum from "@/enum/bookingActionEnum";
import ApartmentStatusColorEnum from "@/enum/apartmentStatusColorEnum";
import apartmentInBooking from "../ApartmentBooking/ApartmentInBooking.vue";
import CheckOutModal from "../ApartmentBooking/CheckOutModal";
import ManagementServiceOrderDetail from "../Service/ManagementServiceOrderDetail.vue"
import utils from '@/lib/utils'

export default {
  components: {
    loading: Loading,
    apartmentInBooking,
    CheckOutModal,
    ManagementServiceOrderDetail
  },
  data: () => ({
    screenHight: 0,
    isLoading: false,
    indexSelect: 0,
    apartmentGroupList: [],
    apartmentIdSelect: null,
    apartmentSelectStatus: null,
    bookingId: null,
    isDisableCheckIn: true,
    isDisableCheckOut: true,
    isDisableService: true,
    // action clean room
    actionCleanText: "apartmentDiagram.actionList.cleanTheRoom",
    actionCleanValue: null,
    apartmentCleanStatus: null,
    notiActionClean: ''
  }),
  watch: {
    GET_APARTMENT_IN_GROUP_LIST_DATA: function() {
      let data = this.GET_APARTMENT_IN_GROUP_LIST_DATA;
      this.apartmentGroupList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          groupName: value.group_name,
          apartment: value.apartment_list
        };
        if (value.id === null) {
          item.groupName = "apartment.otherApartmentGroup";
        }
        this.apartmentGroupList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_APARTMENT_IN_GROUP_LIST_DATA"
    ])
  },
  methods: {
    clickTab: function(value) {
      this.indexSelect = value;
    },
    getApartmentInGroup: function() {
      this.isLoading = true;
      this.GET_APARTMENT_IN_GROUP_LIST()
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    formatDateBooking: function(start, end) {
      let start_date = utils.formatSqlDate(start, null, "DD/MM");
      let end_date = utils.formatSqlDate(end, null, "DD/MM");
      return `${start_date} - ${end_date}`;
    },
    handleResize() {
      this.screenHight =
        window.innerHeight - 382 > 300 ? window.innerHeight - 382 : 300;
    },
    onShowCheckOut: function() {
      this.$refs.checkOutApartmentInBookingModal.onShowModal();
    },
    onClickApartment: function(data) {
      this.apartmentIdSelect = data.id;
      this.apartmentSelectStatus = data.status;
      this.enableAndDisableContextMenu(data.booking_info);
      this.getActionText()
      this.apartmentCleanStatus=this.getApartmentCleanStatus(data.booking_info)
    },
    enableAndDisableContextMenu: function(bookingInfo) {
      if (bookingInfo !== null) {
        this.isDisableCheckIn = false;
        this.bookingId = bookingInfo.booking_id;
      } else {
        this.isDisableCheckIn = true;
        this.bookingId = null;
      }
      if (
        bookingInfo !== null &&
        bookingInfo.status === BookingActionEnum.CHECKED_IN
      ) {
        // this.isDisableService = false;
        this.isDisableCheckOut = false;
      } else {
        // this.isDisableService = true;
        this.isDisableCheckOut = true;
      }
    },
    onCloseModalCheckIn: function() {
      $(this.$refs[`modal-check-in-booking`]).modal("hide");
    },
    onShowModalCheckIn: function() {
      $(this.$refs[`modal-check-in-booking`]).modal("show");
    },
    // clean room
    getActionText: function() {
      if (this.apartmentSelectStatus === ApartmentStatusColorEnum.APARTMENT_IS_CLEANING) {
        this.actionCleanText = 'apartmentDiagram.actionList.roomCleaned'
        this.notiActionClean = 'apartmentDiagram.notiRoomcleaned'
      } else {
        this.actionCleanText = 'apartmentDiagram.actionList.cleanTheRoom'
        this.notiActionClean = 'apartmentDiagram.notiCleanRoom'
      }
    },
    onShowModalCleanRoom: function() {
      $(this.$refs[`modal-clean-room`]).modal("show");
    },
    onHideModalCleanRoom: function() {
      $(this.$refs[`modal-clean-room`]).modal("hide");
    },
    onConfirmCleanRoom: function() {
      this.isLoading = true
      let data = {
        apartmentId: this.apartmentIdSelect,
        status: this.apartmentCleanStatus
      }
      this.ACTION_CLEAN_ROOM(data)
        .then(
          function() {
            this.isLoading = false;
            this.onHideModalCleanRoom()
            this.getApartmentInGroup()
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    getApartmentCleanStatus: function(bookingInfo) {
      if (this.apartmentSelectStatus === ApartmentStatusColorEnum.APARTMENT_IS_CLEANING) {
        if (bookingInfo) {
          if (bookingInfo.status===BookingActionEnum.WAITING_CHECK_IN) {
            return ApartmentStatusColorEnum.APARTMENT_EMPTY
          } else if (this.apartmentSelectStatus===BookingActionEnum.CHECKED_IN) {
            return ApartmentStatusColorEnum.APARTMENT_CHECKED_IN
          }
        } else {
          return ApartmentStatusColorEnum.APARTMENT_EMPTY
        }
      } else {
        return ApartmentStatusColorEnum.APARTMENT_IS_CLEANING
      }
    },
    onShowModalService: function() {
      this.$refs.managementServiceOrderDetail.onGetDataFromApartmentDiagram(this.apartmentIdSelect)
      $(this.$refs[`modal-service-order`]).modal("show");
    },
    onCloseModalAddService: function() {
      $(this.$refs[`modal-service-order`]).modal("hide");
    },
    ...mapActions([
      "GET_APARTMENT_IN_GROUP_LIST",
      "ACTION_CLEAN_ROOM"
    ])
  },
  mounted() {
    this.getApartmentInGroup();
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }
};
</script>
<style scoped>
.apartment-code {
  font-size: 18px;
  text-align: center;
  padding: 30px 0 15px 0;
}

/********************************************************************/
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL PRIMARY ***/
.with-nav-tabs.panel-primary .nav-tabs > li > a,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
}
.with-nav-tabs.panel-primary .nav-tabs > .open > a,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
  background-color: #3071a9;
  border-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.active > a,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:focus {
  color: #428bca;
  background-color: #fff;
  border-color: #428bca;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #428bca;
  border-color: #3071a9;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #fff;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #3071a9;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  background-color: #4a9fe9;
}
.with-nav-tabs.panel-primary .panel-body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentDiagram/ApartmentDiagramList.vue